import { ArrowUturnLeftIcon, CheckIcon } from "@heroicons/react/24/outline";
import { Button } from "../ui";

// Discard and save for a form of unsaved changes; submits the form it sits in
export default function SaveChangesBar({ count, saving, canDiscard = count > 0, onDiscard, className = "" }) {
  return (
    <div className={`flex flex-col-reverse justify-end gap-3 sm:flex-row ${className}`}>
      <Button variant="ghost" onClick={onDiscard} disabled={saving || !canDiscard} icon={<ArrowUturnLeftIcon className="h-4 w-4" />}>
        Discard changes
      </Button>
      <Button type="submit" loading={saving} disabled={!count} icon={<CheckIcon className="h-4 w-4" />}>
        Save {count ? `${count} change${count > 1 ? "s" : ""}` : "changes"}
      </Button>
    </div>
  );
}
